import { AgentProject } from '../agent-project/agent-project.js'
import { ADK_VERSION, formatCode } from './utils.js'
import { createFile } from '../utils/fs.js'
import path from 'path'

export async function generateIntegrationActionTypes(project: AgentProject): Promise<void> {
  const content = `
////////////////////////////////////////////////////////
// DO NOT EDIT THIS FILE DIRECTLY
// This file is auto-generated from the Botpress ADK
// ADK Version: ${ADK_VERSION}
// Generated at: ${new Date().toISOString()}
////////////////////////////////////////////////////////

type Integrations = import("@botpress/runtime/_types/integrations").Integrations;

declare module "@botpress/runtime/_types/integration-actions" {

export interface CallableAction<I, O> {
  (input: I): Promise<O>;
  asTool(): import("@botpress/runtime").Autonomous.Tool;
}

type Callable<T> = T extends { input: infer I; output: infer O }
  ? CallableAction<I, O>
  : never;

type IntegrationsMap<T> = {
  [Integration in keyof T]: T[Integration] extends { actions: infer Actions }
    ? {
        [Action in keyof Actions]: Callable<Actions[Action]>;
      }
    : never;
};

export type IntegrationActions = IntegrationsMap<Integrations>;
}
`

  // Write to integration-action-types.d.ts in the .adk folder
  const integrationActionTypesPath = path.join(project.path, '.adk', 'integration-action-types.d.ts')
  await createFile(integrationActionTypesPath, await formatCode(content))
}
